import { h } from 'preact';

export function ToggleSwitchEntry({ id, label, checked, onChange, disabled = false, description }) {
  const handleClick = () => {
    if (!disabled) onChange(!checked);
  };

  return (
    <div class="epx-entry epx-toggle-switch">
      <label class="epx-entry-label" htmlFor={id} onClick={handleClick}>
        <span class={`epx-toggle-track${checked ? ' on' : ''}`}>
          <span class={`epx-toggle-thumb${checked ? ' on' : ''}`} />
        </span>
        {label}
      </label>
      <input
        id={id}
        type="checkbox"
        checked={!!checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        style="display:none"
      />
      {description && <div class="epx-entry-description">{description}</div>}
    </div>
  );
}
